import React, { useState, useContext, useEffect, useCallback } from 'react'

const url = 'https://www.thecocktaildb.com/api/json/v1/1/search.php?s='
const AppContext = React.createContext()

const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const [searchTerms, setSearchTerms] = useState('a')
  const [cocktails, setCocktails] = useState([])

  const getItems = useCallback(async () => {
    try {
      setLoading(true)
      const response = await fetch(`${url}${searchTerms}`)
      const items = await response.json()
      const { drinks } = items
      if (drinks) {
        const newDrink = drinks.map((item) => {
          const { idDrink, strDrink, strDrinkThumb, strAlcoholic, strGlass } =
            item
          return {
            id: idDrink,
            name: strDrink,
            image: strDrinkThumb,
            info: strAlcoholic,
            glass: strGlass,
          }
        })

        setCocktails(newDrink)
        setLoading(false)
      } else {
        setCocktails([])
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }, [searchTerms])

  useEffect(() => {
    getItems()
  }, [searchTerms, getItems])

  return (
    <AppContext.Provider
      value={{
        loading,
        setSearchTerms,
        cocktails,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext)
}

export { AppContext, AppProvider }

// idDrink - id
// strDrink - name
// strDrinkThumb - image
// strAlcoholic - info
// strGlass - glass
